/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo.ts";

function getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoUrl(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams["courseFinancialId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/course-financials/${courseFinancialId}/info` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/GetCourseFinancialInfo. **(Requer Authorization para autenticação)**
 * @summary Retorna totais e desconto de pontualidade do plano financeiro do curso (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/info}
 */
export async function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams["courseFinancialId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoUrl(
      courseFinancialId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
